import type { FC } from 'react'
import { useState } from 'react'

import CheckboxBlankOutlineIcon from 'mdi-react/CheckboxBlankOutlineIcon'
import CheckboxMarkedOutlineIcon from 'mdi-react/CheckboxMarkedOutlineIcon'

import { useText } from '@/app/translations/translations-hooks'
import type { Department } from '@/types'

const AllDepartmentsCheckbox: FC<{
  departmentList: Department[]
  selectedDepartmentIds: number[] | null
  onDepartmentsSelect: (v: number[] | null) => void
}> = ({ departmentList, selectedDepartmentIds, onDepartmentsSelect }) => {
  const departmentIdList = departmentList?.map(({ id }) => id)
  const [fullDepartmentIdList] = useState(departmentIdList)
  const isSelected =
    departmentIdList.length > 0 &&
    !departmentIdList?.find(id => !selectedDepartmentIds?.includes(id))

  const text = useText('select all')

  const handleClick = () => {
    const filteredList = fullDepartmentIdList.filter(
      id => !departmentIdList.includes(id) && selectedDepartmentIds?.includes(id)
    )

    if (isSelected) {
      onDepartmentsSelect(filteredList.length ? filteredList : null)
      return
    }

    onDepartmentsSelect([...departmentIdList, ...filteredList])
  }

  return (
    <th onClick={handleClick} className={`${isSelected ? 'selected' : ''}`}>
      <div className="check-mark" title={text}>
        {isSelected ? <CheckboxMarkedOutlineIcon /> : <CheckboxBlankOutlineIcon />}
      </div>
    </th>
  )
}

export default AllDepartmentsCheckbox
